import { element } from "prop-types";
import React from "react";


const Dashboard = React.lazy(() => import("./views/dashboard/Dashboard"));

const ChargerScreen = React.lazy(() =>
  import("./views/chargerScreen/ChargerScreen")
);
const AboutUsPage = React.lazy(() => import("./views/aboutUs/AboutUs"));
const ProfileScreen = React.lazy(() =>
  import("./views/profileScreen/ProfileScreen")
);
const NewAbout = React.lazy(() => import("./views/newAbout/NewAbout"));
const LandingPage = React.lazy(() => import("./views/evac/LandingScreen"));
const Support = React.lazy(() => import("./views/evac/CustomerSupport"));
const TermAndCondition = React.lazy(()=>import("./views/termsAndCondition/TermAndCondition"));
const PrivacyPolicy = React.lazy(()=> import("./views/privacyPolicy/PrivacyPolicy"));
const FAQ = React.lazy(() => import("./views/faq/FAQ"));
const routes = [
  { path: "/", exact: true, name: "Home" },
  { path: "/landing", name: "LandingPage", element: LandingPage },
  { path: "/evacsupport", name: "SupportPage", element: Support },
  { path: "/dashboard", name: "Dashboard", element: Dashboard },
  { path: "/aboutUs", name: "AboutUsPage", element: AboutUsPage },
  { path: "/profileScreen", name: "ProfileScreen", element: ProfileScreen },
  { path: "/chargerScreen", name: "ChargerScreen", element: ChargerScreen },
  { path: "/PrivacyPolicy", name: "PrivacyPolicy", element: PrivacyPolicy },
  {
    path: "/TermAndCondition",
    name: "TermAndCondition",
    element: TermAndCondition,
  },
  { path: "/NewAbout", name: "NewAbout", element: NewAbout },
  { path: "/FAQ", name: "FAQ", element: FAQ },
];

export default routes;
